import { getAll } from '../../../api/airtable.js'

const state = {
  ready: false,
  performance: {},
  cast: [],
  authors: [],
  title: [],
  troupe: []
}

const getters = {}
const actions = {
  /**
   * Set up all deep calls
   * TODO MEDIA
   */
  setup({commit}, perf) {
    commit('SET_READY', false)
    commit('SET_PERFORMANCE', perf)
    Promise.all([
      // load cast
      getAll('Cast Members', perf['Cast Members']).then(cast => {
        commit('SET_CAST', { cast, perf })
      }), 

      // TODO CHECK AUTHOR FIELD NAME FOR PLURAL
      // load authors
      getAll('Authors', perf['Author']).then(authors => {
        commit('SET_AUTHORS', { authors, perf })
      }), 
      
      // load authors
      getAll('Plays', perf['Title']).then(title => {
        commit('SET_TITLE', { title: title[0], perf })
      }), 
      
      // load authors
      getAll('Troupes', perf['Troupe']).then(troupe => {
        commit('SET_TROUPE', { troupe: troupe, perf })
      })
    ]).then(() => {
      commit('SET_READY', true)
    })
    

  },
}
const mutations = {
  SET_READY(state, ready) {
    state.ready = ready
  },
  SET_CAST(state, { cast, perf }) {
    if (state.performance === perf)
    state.cast = cast
  },
  SET_TITLE(state, { title, perf }) {
    if (state.performance === perf)
    state.title = title
  },
  SET_TROUPE(state, { troupe, perf }) {
    if (state.performance === perf)
    state.troupe = troupe
  },
  SET_AUTHORS(state, { authors, perf }) {
    if (state.performance === perf)
    state.authors = authors
  },
  SET_PERFORMANCE(state, performance) {
    state.performance = performance
  }
}

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
